import { FC } from "react";
import {
  ApolloClient,
  ApolloLink,
  ApolloProvider,
  from,
  HttpLink,
  InMemoryCache,
} from "@apollo/client";
import { getApiUrl } from "../../utils/apiConfig";
import { getCookie, HM_TOKEN, setAuthToken } from "../../utils/authToken";

const httpLink = new HttpLink({
  uri: getApiUrl("graphql"),
  fetchOptions: { credentials: "omit" },
  fetch: async (uri, options) => {
    const res = await fetch(uri as RequestInfo, options as RequestInit);
    try {
      const authorization = res.headers.get("Authorization");
      if (authorization) setAuthToken(authorization);
    } catch {}
    return res;
  },
});
const authLink = new ApolloLink((operation, forward) => {
  const token = getCookie(HM_TOKEN);
  if (token) {
    operation.setContext({
      headers: { Authorization: `Bearer ${token}` },
    });
  }
  return forward(operation);
});

const client = new ApolloClient({
  link: from([authLink, httpLink]),
  cache: new InMemoryCache(),
});

// For more comprehensive config see the frontend repo:
//   packages/mats/src/components/app/apollo-provider.tsx
// and
//   packages/mats/src/components/app/apollo-cache.tsx
export const ConfiguredApolloProvider: FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};
